<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>CEP</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label>CEP</label>
            <input class="form-control form-control-lg" v-focus v-model="currentUser.Pessoal.Endereco.Cep" type="text" required pattern="\d{5}-?\d{3}" v-mask="'zipcode'" placeholder="_____-___" title="_____-___"/>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      const newData = {
				Pessoal: this.currentUser.Pessoal
			}
      this.$emit('on-submit', newData)
    }
  },
	created() {
		if(!this.currentUser.Pessoal.Endereco) this.currentUser.Pessoal.Endereco = {}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/AddressStep.vue